// component for admin private route
import React, { useState, useEffect } from "react";
import { Route, useLocation, useHistory } from "react-router-dom";
import MasterLayout from "../../layouts/superAdmin/MasterLayout";
import privateApi from "../../services/privateApi";
import { getToken } from "../../services/auth/token";

const SuperAdminPrivateRoute = ({ ...rest }) => {
  const history = useHistory();
  const location = useLocation();

  const [Authenticated, setAuthenticated] = useState(false);
  const [loading, setloading] = useState(true);

  const authChecker = async e => {
    if (!getToken()) {
      history.push("/login/super-admin");
      return;
    }

    const response = await privateApi.get("superadmin/me");

    if (response.status === 200) {
      setloading(false);
      setAuthenticated(true);
    } else {
      history.push("/login/super-admin");
      return;
    }
  };

  useEffect(() => {
    localStorage.setItem("previousPathname", location.pathname);
  }, [location]);

  useEffect(() => {
    authChecker();
  }, []);

  if (loading) {
    return <></>;
  }
  return (
    <Route
      {...rest}
      render={({ props, location }) =>
        Authenticated ? <MasterLayout {...props} /> : <></>
      }
    />
  );
};

export default SuperAdminPrivateRoute;
